/**
 * Utility functions to control the initial loading spinner
 * This allows us to keep the spinner visible until authentication is complete
 */

/**
 * Hides the initial loading spinner that's shown before the React app loads
 */
export const hideInitialSpinner = (): void => {
    const initialSpinner = document.getElementById('initialLoadingSpinner');

    if (initialSpinner) {
        initialSpinner.classList.add('invisible');
    }
};

/**
 * Shows the initial loading spinner
 */
export const showInitialSpinner = (): void => {
    const initialSpinner = document.getElementById('initialLoadingSpinner');

    if (initialSpinner) {
        initialSpinner.classList.remove('invisible');
    }
};
